<template>
    <div class="listmain ">
        <h1 class="firTitle">支付接入</h1>
        <h3 class="sedTitle">自由支付接入</h3>

        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
      1）说明<br>
订单确认页面为OrionOrderDetailActivity,已在SDK声明，该Activity支持自定义主题<br>
2）控件接入<br>
区别于从Push入口进入订单确认页，进行支付操作<br>
          </span>
    </p>
        <highlight-code lang="javascript" v-html="">
           <span>
  // 传入参数context-Context，order-SpeakerHistory.OrderBean
 OrionOrderDetailActivity.start(context, order,
    new ResponseCallBackListener&lt;String&gt;() {
                  @Override
                  public void onSuccess(String str) {

                  }
                  @Override
                  public void onError(String errorCode, String error) {

                  }
 });
       </span>
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
    3）Push接入<br>
从Push信息栏入口Notification进入订单确认页OrionOrderDetailActivity,需要调用pushStartPay方法。
          </span>
        </p>
        <highlight-code lang="javascript" v-html="">
           <span>
 //传入参数activity-Activity, historyId-push的消息Id
 PushStartPay.pushStartPay(activity, historyId,
   new ResponseCallBackListener&lt;String&gt;() {
                @Override
                public void onSuccess(String args) {

                }

                @Override
                public void onError(String errorCode, String error) {

                }
 });
       </span>
        </highlight-code>
        <h3 class="sedTitle">QQ支付接入</h3>

        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
     QQ登录成功后进行VIP小微支付
          </span>
        </p>
        <highlight-code lang="javascript" v-html="">
           <span>
 PushStartPay.weiXinPay(activity,
   new ResponseCallBackListener&lt;String&gt;() {
                @Override
                public void onSuccess(String args) {

                }

                @Override
                public void onError(String errorCode, String error) {

                }
 });
       </span>
        </highlight-code>
        <h3 class="sedTitle">     声纹支付接入
        </h3>

        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
              声纹免密支付
          </span>
        </p>
        <highlight-code lang="javascript" v-html="">
           <span>
  Bundle bundle = new Bundle();
 //sourceFrom 来源页，从哪个页面进入
 bundle.putString(PREVIOUS_NAME_KEY,"sourceFrom");
 bundle.putString(PREVIOUS_CODE_KEY,"0");
 startActivity(com.sdk.orion.ui.baselibrary.activity.ContainsFragmentActivity.getStartIntent(context,
                    OrionAddVoicePrintFragment.class, "title", false,true,bundle));
       </span>
        </highlight-code>
    </div>
</template>

<script>
    export default {
        name: ""
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    h1,
    h2,
    h3,
    h4,
    h5 {
        padding: 0;
        margin: 0px;
        font-weight: normal;
    }

    ul,
    li {
        list-style: none;
    }

    .listmain {
        font-size: 14px;
        line-height: 26px;
        .firTitle {
            font-size: 20px;
            color: #1e4d79;
            margin-bottom: 30px;
        }
        .sedTitle {
            font-size: 16px;
            font-weight: bold;
            padding-bottom: 10px;
            border-bottom: 1px solid #f3f3f3;
            margin-bottom: 15px;
            margin-top: 50px;
            &.fir {
                margin-top: 0px;
            }
        }
        .thirdTitle {
            margin-top: 50px;
            font-weight: bold;
            line-height: 30px;
            font-size: 16px;
        }
        .codeTitle {
            font-weight: bold;
            line-height: 26px;
        }
        pre {
            margin-top: 20px;
        }
        img {
            margin: 30px 0;
            width: 100%;
        }
        table,
        table tr th,
        table tr td {
            border: 1px solid #000;
            text-align: center;
        }
        table {
            line-height: 30px;
            width: 100%;
            border-collapse: collapse;
        }
    }

    .el-submenu .el-menu-item {
        min-width: 190px;
        background: #f5f5f5;
    }

    .el-submenu {
        min-width: 190px;
        background: #f5f5f5;
    }

    img {
        margin-top: 30px;
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-android/Payment_a.vue